angular.module('rjmNg.api').factory("EmailSummaries", [
  "phpServiceUrl"
  "$q"
  "$http"
  "app"
  "modelFactory"
  (phpServiceUrl, $q, $http, app, modelFactory) ->
    EmailSummaries = modelFactory(phpServiceUrl("/client/#{app.getClientId()}/emailsummary"),
      postSave: true)

    # send a test for the given email summary to the proper receipent
    EmailSummaries.sendTest = (modelId, sendTo) ->
      return $http
        method: 'GET'
        url: EmailSummaries.url + '/test/' + modelId
        params:
          send_to: sendTo

    # Gets a list of all bccs for this user.
    EmailSummaries.getBccs = (forceGet = false) ->
      bccList = []
      return EmailSummaries.getCollection(forceGet)
      .then (successResponse) ->
        emailSummaries = successResponse
        _(emailSummaries).each (emailSummary) ->
          bccs = emailSummary.bcc
          _(bccs).each (bcc) ->
            unless _(bccList).contains bcc
              bccList.push bcc
        return bccList
      , (errorResponse) ->
        return errorResponse

    return EmailSummaries
  ]
)
